import { css } from 'styled-components';
import { type Theme, getColor } from 'styles/theme';
import { tertiaryBrandButtonSmall } from 'components/Globals/Base/Button/buttonStyles';
import { breakpoint, font } from 'styles/globals';

export const accoladeWinnerStyles = css<{ theme: Theme }>`
  .accolade-winner-widget {
    font-family: ${font.graphikCond};
    letter-spacing: 0.5px;
    font-size: 16px;
    margin-top: 24px;
    padding-bottom: 16px;
    display: grid;
    grid-template-columns: 45px auto;
    gap: 16px;

    &:not(:last-of-type){
      border-bottom: 2px solid ${getColor('borderPrimary')};
    }

    @media (${breakpoint.mmMin}) {
      grid-template-columns: 70px auto;
      gap: 24px;
      padding-bottom: 24px;
    }

    @media (${breakpoint.lgMin}) {
      gap: 20px 24px;
    }

    &::before {
      content: ' ';
      background: url('/icons/AccoladeMobile.svg') no-repeat center/contain;
      width: 45px;
      height: 79px;
      grid-row: 1;

      @media (${breakpoint.mmMin}) {
        background: url('/icons/Accolade.svg') no-repeat center/contain;
        width: 70px;
        height: 139px;
        grid-column: 1;
        grid-row: span 3;
      }
    }

    & mark {
      color: ${getColor('textSecondary')};
    }

    & h2 {
      font-size: 20px;
      line-height: 24px;
      grid-column: 2;
      grid-row: 1;
      margin: 0;

      @media (${breakpoint.mmMin}) {
        font-size: 24px;
        line-height: 28px;
      }

      @media (${breakpoint.lgMin}) {
        font-size: 32px;
        line-height: 38px;
      }
    }

    & p {
      grid-row: 2;
      grid-column: 1 / span 2;
      margin: 0;

      @media (${breakpoint.mmMin}) {
        grid-column: 2;
      }
    }

    & .read-more-link {
      margin: 0;    
      grid-row: 3;
      position: relative;
      
      a {
        ${tertiaryBrandButtonSmall};
      }
    }
  }
`;
